import React, { InputHTMLAttributes, ReactNode } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import InformationTag from '../InfoTag/InfoTag';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  itemNumber?: number;
  register: UseFormRegisterReturn;
  labelName?: ReactNode;
  fieldName: string | "field";
  infoTagMessage?: string | " ";
  errors?: Record<string, any>; // Form state errors
  
}

const InputField: React.FC<InputProps> = ({ register, labelName, fieldName, errors,infoTagMessage, itemNumber, ...rest }) => {
  return (
    <div className="mb-8">
      <div className="flex">
        { itemNumber != undefined && (
          <div className="flex-none w-5 text-sm">{itemNumber}.</div>
        )}
        <div className="text-sm grid grid-cols-2"><div>{labelName}</div> { infoTagMessage != undefined && ( <div className="ml-2"><InformationTag message={infoTagMessage} /></div> )}</div>
      </div>
      <div className="flex">
        { itemNumber != undefined && (
          <div className="flex-none w-5"></div>
        )}
        <div className="grow mt-3">
          <input
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            {...rest}
            {...register} // This spreads the register function correctly
          />
          {errors && errors[fieldName] && (
            <div className="text-red-500 text-xs pt-2">{errors[fieldName].message}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InputField;